import Describe from './Describe';
export type { DescribeProps } from './Describe.types';

export default Describe;
